export const STUDIO_FILTERS = {
  search: '',
  archived: false,
  paging: {
    page: 1,
    perPage: 5
  },
  sorting: {
    key: 'order',
    dir: 'asc',
    options: {
      created: {
        label: 'label.LAST_UPDATED',
        value: 'order',
        enabled: true
      },
      rulename: {
        label: 'label.NAME',
        value: 'rulename',
        enabled: false
      },
      status: {
        label: 'label.STATUS',
        value: 'active',
        enabled: false
      }
    }
  }
};
